module.exports = __webpack_public_path__ + "img/vetorpainel.3c76a047.svg";